import './UsersPageModals.scss';

import React from 'react';
import Modal from 'components/Modal';

import ModalButton from 'components/ModalButton';
import SlideList from 'components/SlideList';
import Thumbnail from 'components/Thumbnail';

import { MODALS } from 'utils/constants';

export default class GroupDetailsModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        deleteGroup: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        group: React.PropTypes.object.isRequired
    };

    render() {
        let { closeModal, deleteGroup, group, openModal, isFetching, isSaving, show } = this.props;

        if(Object.keys(group).length > 0 && group.id !== undefined) {
            return (
                <Modal show={show && Object.keys(group).length > 0 && group.id !== undefined}
                       className="group-details"
                       handleClose={closeModal.bind(this)}>
                    <header className="user-details__header user-modal__header">
                        <div className="user-modal__thumbnail">
                            <Thumbnail defaultAvatar="groups"
                                       thumbnailID={group.thumbnail ? group.thumbnail.id : null} />
                        </div>
                        <div className="user-details__name">
                            {group.name}
                        </div>
                    </header>
                    <div className="details-modal__info group-details__info">
                        Group Description
                        <div className="group-details__description modal__description">
                            {group.description || '[No specified description]'}
                        </div>
                    </div>

                    <SlideList className="group-details__assignments-list group-details__list details-modal__list"
                               count={group.assignmentIds.length}
                               icon="assignments"
                               items={group.assignments || []}
                               title="Assignments"
                               type="assignments" />

                    <SlideList className="group-details__users-list group-details__list details-modal__list"
                               count={group.userIds.length}
                               icon="groups"
                               isFetching={isFetching}
                               items={group.users || []}
                               title="Users"
                               type="users" />

                    <div className="modal__buttons">
                        <ModalButton disabled={isSaving === true}
                                     icon="edit"
                                     onClick={openModal.bind(this, MODALS.GROUP_EDIT)}
                                     text="Edit" />
                        <ModalButton disabled={isSaving === true}
                                     icon="delete"
                                     onClick={deleteGroup.bind(this, group)}
                                     text="Remove" />
                    </div>

                </Modal>
            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/GroupDetailsModal.js